import { render, staticRenderFns } from "./handlerModal.vue?vue&type=template&id=5b675a92"
import script from "./handlerModal.vue?vue&type=script&lang=js"
export * from "./handlerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports